import React, { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useKeycloak } from "@react-keycloak/web";
import { useSelector } from "react-redux";
import { RootState } from "../store/store";
import { IS } from "@lxp-app/store/slices/userInfoSlice";
import Header from "@lxp-app/layouts/header/header-new";
import Footer from "@lxp-app/layouts/footer/footer";
import BreadCrumb from "@lxp-app/components/molecules/breadcrumb/breadCrumb";
import { Sidebar } from "@assessment/components/atoms/Sidebar";
import UserRole from "@lxp-app/utils/roles";
import { useDispatch } from "react-redux";
// import BreadCrumb from  "@lxp-app/layouts/breadcrumb/breadcrumb";
const breadcrumExcludedPaths = [
  "/",
  "/interview",
  "/generate-questions",
  "/authoring/assessment-authoring",
  "/authoring/question-paper-authoring"
];
const iframePaths = ["/interview", "/generate-questions"];
const sideBarExcludedPaths = ["/error/user-not-found", "/logout"];
const MainWrapper = ({ children }: { children: React.ReactNode }) => {
  const { keycloak } = useKeycloak();
  const location = useLocation();
  const user: IS = useSelector((state: RootState) => state.UserInfoSlice);
  const AppData = useSelector((state: RootState) => state.AppMetaDataSlice);
  const dispatch = useDispatch();
  const isAssessmentCandidate = useMemo(() => {
    let isCandidate = false;
    isCandidate = !user?.profile?.role?.some((role) =>
      [
        UserRole.AI_AUTHORING_CREATOR,
        UserRole.ASSESSMENT_ADMIN,
        UserRole.ASSESSMENT_CREATOR,
        UserRole.INTERVIEW_ADMIN,
        UserRole.ROLE_ADMIN
      ].includes(role)
    );
    return isCandidate;
  }, [user?.profile?.role]);

  const isAssessmentPage =
    location.pathname.includes("assessment") &&
    !location.pathname.includes("authoring");

  return (
    <main className="flex flex-col w-full h-screen overflow-hidden transition-colors duration-300">
      {/* 1. TOP: Header & Breadcrumb (Fixed to top by flex-none) */}
      {AppData.header &&
        !location.pathname.includes("user-not-found") &&
        !location.pathname.includes("/logout") &&
        isAssessmentCandidate && <Header />}

      {/* 2. MIDDLE: Sidebar + Content (Expands to fill remaining height) */}
      <div className="flex flex-1 flex-row h-[calc(100vh-100px)]">
        {!isAssessmentPage &&
          !sideBarExcludedPaths.includes(location.pathname) &&
          !isAssessmentCandidate && <Sidebar />}

        <div
          className={`flex-1 ${isAssessmentPage ? "!h-full" : "max-h-[calc(100vh-12px)] overflow-y-auto"} ${iframePaths.includes(location.pathname) ? "flex" : "px-4 lg:px-8"} ${location.pathname.includes("/logout") || isAssessmentPage ? "!px-0" : ""}`}
        >
          {iframePaths.includes(location.pathname) ? (
            children
          ) : (
            <div
              id="main-content"
              className="h-full overflow-y-auto thin-scrollbar"
            >
              {keycloak.authenticated &&
                !user.profile.unAuthorized &&
                !breadcrumExcludedPaths.includes(location.pathname) &&
                AppData.breadcrumb && <BreadCrumb />}
              {children}
            </div>
          )}
        </div>
      </div>

      {/* 3. BOTTOM: Footer (Stays at the very bottom, no overlap) */}
      <div className="flex-none w-full z-50">
        {!location.pathname.includes("/logout") && AppData.footer && <Footer />}
      </div>
    </main>
  );
};

export default MainWrapper;
